// @ts-nocheck
import React from 'react';

const IntFloorPlanPianoPrimo5 = () => {
    return (
        <>
            <svg className="interactive-floor-plan-map" style={{width: '100%'}} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 1109 587">
                <image xlinkHref="/images/interactive-floor-plans/Piano primo/5_Piano_Primo_P1_SALA-A7.png" style={{width: '1109px'}}></image>
                <a xlinkHref="/?room=30" target="_self" xlinkTitle="Sala A1">
                    <g>
                        <rect x="578" y="16" width="44" height="44" className="image-mapper-shape" data-index="1"></rect>
                    </g>
                </a>
                <a xlinkHref="/?room=31" target="_self" xlinkTitle="Sala A2">
                    <g>
                        <rect x="670" y="16" width="44" height="44" className="image-mapper-shape" data-index="2"></rect>
                    </g>
                </a>
                <a xlinkHref="/?room=32" target="_self" xlinkTitle="Sala A3">
                    <g>
                        <rect x="732" y="16" width="44" height="44" className="image-mapper-shape" data-index="3"></rect>
                    </g>
                </a>
                <a xlinkHref="/?room=33" target="_self" xlinkTitle="Sala A4">
                    <g>
                        <rect x="791" y="16" width="44" height="44" className="image-mapper-shape" data-index="4"></rect>
                    </g>
                </a>
                <a xlinkHref="/?room=35" target="_self" xlinkTitle="Sala B2">
                    <g>
                        <rect x="786" y="198" width="44" height="44" className="image-mapper-shape" data-index="6"></rect>
                    </g>
                </a>
                <a xlinkHref="/?room=36" target="_self" xlinkTitle="Sala B4">
                    <g>
                        <rect x="818" y="343" width="44" height="44" className="image-mapper-shape" data-index="7"></rect>
                    </g>
                </a>
                <a xlinkHref="/?room=37" target="_self" xlinkTitle="Sala C4">
                    <g>
                        <rect x="559" y="343" width="44" height="44" className="image-mapper-shape" data-index="8"></rect>
                    </g>
                </a>
                <a xlinkHref="/?room=38" target="_self" xlinkTitle="Sala D2">
                    <g>
                        <rect x="472" y="425" width="44" height="44" className="image-mapper-shape" data-index="9"></rect>
                    </g>
                </a>
                <a xlinkHref="/?room=39" target="_self" xlinkTitle="Sala D3">
                    <g>
                        <rect x="418" y="476" width="44" height="44" className="image-mapper-shape" data-index="10"></rect>
                    </g>
                </a>
                <a xlinkHref="/?room=40" target="_self" xlinkTitle="Sala D1">
                    <g>
                        <rect x="395" y="425" width="44" height="44" className="image-mapper-shape" data-index="11"></rect>
                    </g>
                </a>
                <a xlinkHref="/?room=41" target="_self" xlinkTitle="Sala D5">
                    <g>
                        <rect x="438" y="352" width="44" height="44" className="image-mapper-shape" data-index="12"></rect>
                    </g>
                </a>
                <a xlinkHref="/?room=42" target="_self" xlinkTitle="Sala G">
                    <g>
                        <rect x="418" y="180" width="44" height="44" className="image-mapper-shape" data-index="13"></rect>
                    </g>
                </a>
                <a xlinkHref="/?room=43" target="_self" xlinkTitle="Sala H1">
                    <g>
                        <rect x="271" y="275" width="44" height="44" className="image-mapper-shape" data-index="14"></rect>
                    </g>
                </a>
                <a xlinkHref="/?room=44" target="_self" xlinkTitle="Sala H3">
                    <g>
                        <rect x="93" y="266" width="44" height="44" className="image-mapper-shape" data-index="15"></rect>
                    </g>
                </a>
            </svg>
        </>
    );
};

export default IntFloorPlanPianoPrimo5;
